<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h3>Thông tin phòng ban</h3>
            </div>
        </div>

        <div class="vx-row mt-2">
            <div class="vx-col sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Chi nhánh</label>
                <span class="text-sm text-danger">*</span>
                <v-select class="w-full" v-model="departmentInfo.organizationBranchId" :options="branchOptions" :clearable="false"
                          name="branch" v-validate="'required'" :reduce="item => item.value" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Tên phòng ban</label>
                <span class="text-sm text-danger">*</span>
                <vs-input class="w-full" v-model="departmentInfo.departmentName" name="departmentName"
                          v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </vs-input>
                <span class="text-danger text-sm">{{ errors.first('departmentName') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Loại phòng ban</label>
                <v-select class="w-full" v-model="departmentInfo.type" :options="departmentTypeOptions" :clearable="true"
                          name="branchType" :reduce="item => item.value">
                </v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mt-4">
                <label class="vs-input--label">Tên viết tắt</label>
                <span class="text-sm text-danger">*</span>
                <vs-input class="w-full" v-model="departmentInfo.alias" name="alias"
                          v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </vs-input>
                <span class="text-danger text-sm">{{ errors.first('alias') }}</span>
            </div>
        </div>

        <div class="vx-row mt-4">
            <div class="vx-col w-full float-right">
                <div class="flex flex-wrap mb-5">
                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                               v-if="isPermissionAll">
                        {{ `${isUpdate ? 'Cập nhật' : 'Tạo mới'}` }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/user/manage-department')">Quay lại
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {isAPI} from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";

export default {
    components: {
        vSelect,
    },

    data() {
        return {
            branchOptions: [],
            isUpdate: false,
            departmentInfo: {
                departmentName: null,
                organizationBranchId: null,
                type: null,
            },
            departmentTypeOptions: [
                {value: 1, label: 'P.Kinh doanh 1'},
                {value: 2, label: 'P.Kinh doanh 2'},
                {value: 4, label: 'P.Kinh doanh 3'},
                {value: 5, label: 'P.Kinh doanh 4'},
                {value: 3, label: 'P.Tư vấn'},
            ],
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any();
        },
    },

    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        let departmentId = parseInt(this.$route.query.departmentId, 10);
        let branchId = parseInt(this.$route.query.branchId, 10)
        if (departmentId && branchId) {
            this.departmentInfo.organizationBranchId = branchId
            this.isUpdate = true;
            this.findById(departmentId);
        }
    },

    methods: {
        isPermissionAll() {
            return isAPI(this, constAPI.department_all)
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            let url = this.isUpdate ? '/department/update' : '/department/create';

            this.$vs.loading();
            this.$crm.post(url, this.departmentInfo).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật ' : 'Tạo mới '} phòng ban thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                setTimeout(() => {
                    this.$router.push('/user/manage-department');
                }, 1000)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        findById(departmentId) {
            this.$vs.loading();
            this.$crm.get(`/department/find-by-id?id=${departmentId}`).then(res => {
                this.departmentInfo = res.data;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    }
}
</script>
